import React, { useEffect, useState, useCallback } from 'react';

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import { Link } from 'react-router-dom';

import { Divider } from '@material-ui/core';

import { FiEdit3 } from 'react-icons/fi';

import api from '../../services/api';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import * as S from './styles';

import Toggle from '../../newComponents/Toggle';

export interface TableProps {
  id: string;
  nome: string;
  cargo: string;
  email: string;
  ativo: boolean;
}

const Funcionario: React.FC = () => {
  const [funcionarios, setFuncionarios] = useState<TableProps[]>([]);

  const { user } = useAuth();
  const { addToast } = useToast();

  useEffect(() => {
    async function loadFuncionarios(): Promise<void> {
      const response = await api.get(
        `/usuario/funcionarios/${user.empresa_id}`,
      );

      const funcionarioItems: TableProps[] = [];

      response.data.map((item: any): void => {
        const funcionarioFormat = {
          id: item.id,
          nome: item.nome,
          cargo: item.cargo,
          email: item.email,
          ativo: item.ativo,
        };

        funcionarioItems.push(funcionarioFormat);
      });

      setFuncionarios(funcionarioItems);
    }

    loadFuncionarios();
  }, [user]);

  const handleChangeAtivo = useCallback(
    (funcId: string, funcIsActive: boolean) => {
      try {
        api
          .put(`usuario/funcionarios/${funcId}`, { ativo: funcIsActive })
          .then((response) => {
            if (response.data.ativo) {
              addToast({
                type: 'success',
                title: 'Funcionário ativado',
              });
            } else {
              addToast({
                type: 'success',
                title: 'Funcionário desativado',
              });
            }

            setFuncionarios(
              funcionarios.map(
                (func): TableProps =>
                  func.id === funcId
                    ? { ...func, ativo: response.data.ativo }
                    : func,
              ),
            );
          });
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao desativar funcionário',
        });
      }
    },
    [addToast, funcionarios],
  );

  return (
    <S.Container>
      <div className="header">
        <h2>Edite os dados dos funcionários</h2>
      </div>

      <Divider />

      <div className="create_user">
        <Link to="/funcionario/new">Adicionar Funcionário</Link>
      </div>

      <S.ContainerList>
        <S.CustomTable>
          <S.TableHeader>
            <S.TableCell>
              <th style={{ justifyContent: 'center', display: 'flex' }}>
                Nome
              </th>
            </S.TableCell>
            <S.TableCell>
              <th style={{ justifyContent: 'center', display: 'flex' }}>
                Cargo
              </th>
            </S.TableCell>
            <S.TableCell>
              <th style={{ justifyContent: 'center', display: 'flex' }}>
                E-mail
              </th>
            </S.TableCell>
            <S.TableCell>
              <th style={{ justifyContent: 'center', display: 'flex' }}>
                Editar
              </th>
            </S.TableCell>
            <S.TableCell>
              <th style={{ justifyContent: 'center', display: 'flex' }}>
                Status
              </th>
            </S.TableCell>
            <S.TableCell />
          </S.TableHeader>
          <S.TableBody>
            {funcionarios && (
              <DragDropContext
                onDragEnd={() => {}}
              >
                <Droppable droppableId="droppableProducts">
                  {(droppableProvided) => (
                    <tr
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      {funcionarios
                        .map((funcionario, funcionarioIndex) => (
                          <Draggable
                            key={funcionario.id}
                            draggableId={String(funcionario.id)}
                            index={funcionarioIndex}
                          >
                            {(draggableProvided) => (
                              <td
                                ref={draggableProvided.innerRef}
                                {...draggableProvided.draggableProps}
                              >
                                <S.TableRow>
                                  <S.TableCellRow>
                                    <p>{funcionario.nome}</p>
                                  </S.TableCellRow>
                                  <S.TableCellRow>
                                    <p>{funcionario.cargo}</p>
                                  </S.TableCellRow>
                                  <S.TableCellRow>
                                    <p>{funcionario.email}</p>
                                  </S.TableCellRow>
                                  <S.TableCellRow>
                                    <Link to={`/funcionario/edit/${funcionario.id}`}>
                                      <FiEdit3 size={20} />
                                    </Link>
                                  </S.TableCellRow>
                                  <S.TableCellRow>
                                    <Toggle
                                      checked={funcionario.ativo}
                                      firstText="Pausado"
                                      secondText="Ativado"
                                      onToggle={(value) => handleChangeAtivo(funcionario.id, value)}
                                    />
                                  </S.TableCellRow>
                                </S.TableRow>
                              </td>
                            )}
                          </Draggable>
                        ))}
                        {droppableProvided.placeholder}
                    </tr>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </S.TableBody>
        </S.CustomTable>
      </S.ContainerList>
    </S.Container>
  );
};

export default Funcionario;
